import React, {Component} from 'react';
import './App.scss';
import {Route} from "react-router-dom";

import {reduxWrapper} from "./globalState";
import Asciidoc from "./lib/asciidoc";
import docs from './docs/index.adoc';
import ArticleView from "./components/views/articleView";
import UserViews from "./components/userPages/userViews";
import TermsOfTrade from "./components/infoPages/termsoftrade";
import TermsOfUse from "./components/infoPages/termsofuse";
import Shipping from "./components/infoPages/shipping";
import Cookies from "./components/infoPages/cookies";
import {RelativeSwitch} from "./components/common/common";
import {Affiliate, AffiliateRedirect} from './components/affiliate';
import FrontPage from './components/frontPage';
import {ModalContext} from './contexts';
import {CookieWindow, FirstLogin, SmartLogin} from "./components/structure";
import Bundles from './components/views/bundles';
import Checkout from "./components/views/checkout";
import Reserve from './components/views/reserve';
import MyParty from './components/views/myparty';
import {TileView} from './components/views/tileView';

class AppRender extends Component {
	state = {
		modal:{
			show: false,
			modalType: "",
			toggleModal: (status, modal = "") => this.setState({modalType: modal, show: status})
		}
	}

	virtualRoute = "";

	componentDidMount() {
		//Pushing to google tagmanager's dataLayer
		//Because we have an OPA all page views are pushed as virtual page views. 
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'VirtualPageview',
			'pagePath': window.location.pathname
		});
		
		this.virtualRoute = window.location.pathname;
	}
	
	componentDidUpdate() {
		//Only pushing new page view to GTM's dataLayer if the url has changed.
		if (window.location.pathname !== this.virtualRoute) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'VirtualPageview',
				'pagePath': window.location.pathname
			});
			this.virtualRoute = window.location.pathname;
		}
	}
	
	render() {
		const {partyExists} = this.props;
		return (
			<ModalContext.Provider value={this.state.modal}>
				{/*<RelativeSwitch>
					 <Route path="/invite/:token" render={({match: {params: {token}}}) => <LoginView token={token}/>}/>
				</RelativeSwitch> */}

				<div className="mainContent" id="content">
					<RelativeSwitch>
						{/* <Route path="/log-ind" render={() => <TileView/>}/> */}
						<Route path="/docs" component={Documentation}/>
						<Route path="/inspiration" component={ArticleView}/>
						<Route path="/mine-sider" component={UserViews}/>
						<Route path="/affiliate" component={Affiliate}/>
						<Route path="/partner/:code" render={({match: {params: {code}}}) => <AffiliateRedirect code={code}/>}/>
						<Route exact path="/handelsbetingelser" component={TermsOfTrade}/>
						<Route exact path="/brugsbetingelser-datapolitik" component={TermsOfUse}/>
						<Route exact path="/levering" component={Shipping}/>
						<Route exact path="/cookies" component={Cookies}/>
						
						<Route path="/checkout" render={() => <Checkout/>}/>
						
						{/* New URL'S */}
						<Route path="/minfest" render={() => <MyParty/>}/>
						{/* <Route path="/minfest" render={() => <TileView/>}/> */}
						<Route path="/reservere" render={() => <Reserve/>}/>
						{/* <Route path="/konkurrence" component={Competition}/> */}
						<Route path="/pakker" render={() => <Bundles/>}/>
						<Route path="/login/first" component={FirstLogin}/>
						<Route path="/login/smart/:hash" render={({match: {params: {hash}}}) => <SmartLogin hash={hash}/>}/>
						
						<Route render={() => <FrontPage partyExists={partyExists}/>}/>
						
					</RelativeSwitch>
					<CookieWindow/>
				</div>

				{/* Modal */}
				{this.state.modalType}
			</ModalContext.Provider>
		);
	}
}

const App = reduxWrapper("getUserId", "getPartyExists", "getCreateParty")(AppRender);

class Documentation extends Component {
	render() {
		return (
			<Asciidoc
				source={docs}/>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js